import angular from 'angular';
import { countBy, filter, find, forEach, get, isEmpty, isString, map, some } from 'lodash';
import moment from 'moment-timezone';
import '../app.constants';
import '../resources/subscription';
import '../services/globals';
import '../services/errors';
import '../services/subscription';
import '../services/line';
import '../services/area';
import '../services/queue';
import '../services/user';
import '../services/socket';
import '../services/notifications';
import '../factories/socket.io';
import './modals/enqueue';
import './modals/auto-call-reason';
import './modals/info';
import './modals/forward';
import '../components/carousel';
import Action from '../enums/action';
import { getDifferenceTime, getWaitingTime, restartTimer, statusNotAllowed } from '../utils';
import { setPriorityIcon, setTypeIcon } from '../utils/subscriptionIcons';
import {
  CallingAutomaticallyDefaultValue,
  CallingAutomaticallyReason,
  CallingAutomaticallyStatus,
} from '../enums/callingAutomatically';

const module = angular.module('whyline.controllers.queue', [
  'whyline.constants',
  'whyline.resources.subscription',
  'whyline.services.globals',
  'whyline.services.errors',
  'whyline.services.subscription',
  'whyline.services.line',
  'whyline.services.area',
  'whyline.services.queue',
  'whyline.services.user',
  'whyline.services.notifications',
  'whyline.services.socket',
  'whyline.factories.socket',
  'whyline.modals.enqueue',
  'whyline.modals.auto-call-reason',
  'whyline.modals.info',
  'whyline.modals.forward',
  'whyline.components.carousel',
]);

const QueueController = (
  QueueService,
  UserService,
  SubscriptionService,
  ErrorService,
  GlobalsService,
  NotificationService,
  PlaceService,
  OrganizationService,
  $scope,
  $uibModal,
  $state,
  $timeout,
  $translate,
  dialog,
  $rootScope,
  screenSize,
  SocketService,
) => {
  /* @ngInject */

  const { lineId, areaId, groupId } = $state.params;
  const userId = UserService.GetCurrent()._id;
  UserService.GetCurrentAsPromise().then(currentUser => {
    $scope.user = currentUser;
    $scope.autoCallStatus = get(currentUser, 'callingAutomatically', CallingAutomaticallyDefaultValue);
    const { organizationId, _id: placeId } = $scope.place;
    $rootScope.$on('socket-ready', () => {
      console.log("Socket Ready!")
      $rootScope.$emit('organization-join', organizationId);
      $rootScope.$emit('place-join', placeId);
    })
  });
  let enqueueIn = {};
  $scope.quantityOfItems = 8;
  $scope.choosingCompletionState = {};
  $scope.subscriptions = {};
  $scope.processing = {};
  $scope.showComplete = false;
  $scope.canCall = false;
  $scope.canDone = true;
  $scope.showTrackingData = false;
  $scope.extraData = {};
  $scope.showCompanyData = false;
  $scope.showSegment = false;
  $scope.showCategory = false;
  $scope.processingMetadata = {};
  $scope.onTimeoutCurrentId = null;
  $scope.showCommercialOfferData = false;
  $scope.showOfficialOperator = false;
  $scope.movementsHistory = [];
  $scope.showForwarded = false;
  $scope.operatorForwardedData = {};
  $scope.queueForwadedName = '';
  $scope.showCommercialProductsData = false;
  $scope.autoCallActive = false;
  $scope.subscriptionsAmount = {
    waiting: 0,
    done: 0,
    inPlace: 0,
    waitingCheckedIn: 0,
  };
  $scope.place = PlaceService.GetCurrent();
  $scope.enableTimer = true;
  const size = screenSize.get();
  $scope.showHr = size === 'xs' || size === 'sm' ? true : false;
  $scope.filters = [
    { key: 'total', label: 'total in line' },
    { key: 'inPlace', label: 'in place' },
  ];
  $scope.promise = null;
  PlaceService.GetCurrentAsPromise().then((place) => {
    $scope.filterData = {
      showFilters: place.configuration.showWaitingInLineInPlace,
      selectedFilter: 'total',
    };
    $scope.aliasType = place.configuration.aliasType;
    $scope.checkDurationCompleteAction = get(place, 'configuration.checkDurationCompleteAction', {});
  });
  $scope.applyFilter = (filter) => {
    $scope.filterData.selectedFilter = filter.key;
  };
  $scope.getDifferenceTimeQueue = getDifferenceTime;
  $scope.getWaitingTimeQueue = getWaitingTime;
  $scope.statusNotAllowedQueue = statusNotAllowed;
  PlaceService.GetServerTime($scope.place._id.toString()).then((serverTime) => {
    const placeTimezone = get(serverTime, 'placeTimezone', '');
    const localTimeInPlaceTimezone = moment().tz(placeTimezone);
    const difference = moment
      .utc(moment(get(serverTime, 'placeCurrentTime', ''))
        .diff(moment(localTimeInPlaceTimezone))).format('HH:mm:ss');
    const duration = moment.duration(difference);

    $scope.serverTime = serverTime;
    $scope.secondsDifference = duration.asSeconds();
    $scope.placeTimezone = placeTimezone;
  });

  $scope.filterSubscriptions = (item) => {
    if (item) {
      switch ($scope.filterData.selectedFilter) {
        case 'total':
          return true;
        case 'inPlace':
          return item.statusInfo.reason === 'checked-in';
        default:
        // no default
      }
    }
  };

  screenSize.on('xs, sm', function (isMatch) {
    $scope.showHr = isMatch;
  });

  $scope.toggleShowComplete = () => {
    $scope.showComplete = !$scope.showComplete;
  };

  $scope.metadata = { data: [] };

  $scope.getShowName = SubscriptionService.getShowName;
  $scope.getShowNameWithArea = SubscriptionService.getShowNameWithArea;

  const getSubscriptionsAmount = async (subscriptions) => {
    $scope.subscriptionsAmount.waitingCheckedIn = 0;
    forEach(subscriptions, (value, key) => {
      setTypeIcon(value);
      setPriorityIcon(value);

      if (value.status === 'waiting' && value.reason === 'checked-in') {
        $scope.subscriptionsAmount.waitingCheckedIn++;
      }

      if (value.status === 'canceled' && value.reason === 'queue-clear') {
        Reflect.deleteProperty(subscriptions, key);
      }
    });
    const amount = countBy(subscriptions, 'status');
    const amountReason = countBy(subscriptions, 'statusInfo.reason');
    $scope.subscriptionsAmount.waiting = amount.waiting || 0;
    $scope.subscriptionsAmount.done = (amount.completed || 0) + (amount.canceled || 0);
    $scope.subscriptionsAmount.inPlace = amountReason['checked-in'] || 0;
    $scope.canCall = $scope.subscriptionsAmount.waitingCheckedIn > 0;
    if ($scope.currentQueue) {
      const current = {
        _id: $scope.currentQueue._id,
        waiting: $scope.subscriptionsAmount.waiting,
        type: $scope.currentQueue.type,
        inPlace: $scope.subscriptionsAmount.inPlace,
      };

      if (groupId) {
        const lines = countBy(filter(subscriptions, ['status', 'waiting']), 'lineId');

        // HACK: lines waiting by total in the list
        forEach(get($scope.currentQueue, 'lines'), (line) => {
          // HACK: recount checked-in subscriptions belonging to each group line
          const subscriptionsInPlace = filter(
            filter(subscriptions, ['lineId', line._id.toString()]),
            (subscription) => subscription.statusInfo.reason === 'checked-in'
          );
          line.inPlace = subscriptionsInPlace.length;

          const count = get(lines, line._id, null);

          if (count !== null) {
            line.waitingPeople = count;
          }
        });
      }

      $rootScope.$broadcast('update-active-queue', { currentQueue: current });
    }
  };

  const getSubscritionMetadata = (subscription) => {
    $timeout(async () => {
      try {
        $scope.metadata.data = [];
        if (!subscription || !subscription._id) {
          return;
        }

        const _id = isString(subscription) ? subscription : subscription._id;

        const response = await SubscriptionService.getSubscritionMetadata(_id);

        $scope.$apply(() => {
          const {
            status,
            data: { metadata },
          } = response;

          const isNotOk = status !== 200;

          $scope.metadata.data = isNotOk
            ? []
            : metadata.map((data) =>
              Object.keys(data)
                .reduce((d, k) => {
                  d[k] = data[k].replace(/\\n/gi, '\n');
                  return d;
                }, {}),
            );
        });
      } catch (err) {
        console.log('getSubscritionMetadata, err =>', err);
      }
    });
  };

  // Get the processing subscription
  $scope.$watch(
    'subscriptions',
    (newVal) => {
      // Update if someone is processing
      $scope.processing = find(newVal, {
        status: 'processing',
        calledBy: userId,
      });

      setIconsForNewSubscriptions(newVal);

      if ($scope.autoCallStatus &&
        $scope.autoCallStatus.status === CallingAutomaticallyStatus.Active &&
        !$scope.processing) {

        getAllSubscriptions()
          .then(() => {

            // retrieve and update the current subs being processed
            $scope.processing = find($scope.subscriptions, {
              status: 'processing',
              calledBy: userId,
            });

            // call next subs if it hasn't been done yet
            if ($scope.canCall &&
              $scope.canDone &&
              !$scope.processing) {

              return $scope.autoCallNext(newVal)
                .then(() => $scope.afterAutoCallNext())
                .catch((error) => {
                  ErrorService.handler(error);
                });
            }
          })
          .catch((error) => {
            console.error("Error getting subscriptions: ", error);
          });
      }

      $scope.counter = 0;
      $scope.realWaitingTime = restartTimer($scope.place);
      if ($scope.processing && $scope.processing.calledTime) {
        $scope.realWaitingTime = getWaitingTime($scope.processing, $scope.secondsDifference, $scope.placeTimezone);
        $scope.onTimeoutCurrentId = setTimeout($scope.onTimeoutCurrent, 1000);
      }
      $scope.showTimer = $scope.showAttentionTimer && $scope.processing;
      $scope.extraData = {};
      $scope.promise = null;
      if ($scope.processing && $scope.processing.extraData && $scope.processing.extraData.tracking && !$scope.promise) {
        $scope.promise = SubscriptionService.GetExternalData($scope.processing.extraData.tracking);
      } else {
        $scope.showTrackingData = false;
        $scope.extraData = {};
      }
      if ($scope.promise) {
        $scope.promise.then(response => {
          $scope.showTrackingData = true;
          $scope.extraData = response;
        })
      }
      if (get($scope.processing, '_id', '')) {
        $scope.showCompanyData = (
          !isEmpty(get($scope.processing, 'onBehalfOf.companyCuit', '')) &&
          !isEmpty(get($scope.processing, 'onBehalfOf.companyName', ''))
        );
        $scope.movementsHistory = get($scope.processing, 'movementsHistory', []);
        if ($scope.movementsHistory.length > 1 && $scope.movementsHistory[0].action === Action.forward) {
          $scope.showForwarded = true;
          $scope.operatorForwardedData = get($scope.movementsHistory[0], 'operatorInfo', '');
          $scope.queueForwadedName = get($scope.movementsHistory[1], 'queueName', '');
        }
        $scope.showCommercialOfferData = !isEmpty(get($scope.processing, 'extraData.commercialOffer.commercialMessage.shortMessage', ''));
        $scope.showCommercialProductsData = !isEmpty(get($scope.processing, 'extraData.commercialOffer.commercialProducts', []));
        $scope.processingMetadata = get($scope.processing.extraData, 'metadata[0]', '');
        $scope.showSegment = !isEmpty(get($scope.processingMetadata, 'SEGMENTO', ''));
        $scope.showCategory = !isEmpty(get($scope.processingMetadata, 'CATEGORIA', ''));
        $scope.showOfficialOperator = !isEmpty(get($scope.processing, 'officialOperator.email', ''));
      }
      if ($scope.processing && !$scope.processing.fullName) {
        $scope.processing.fullName = $scope.getShowName($scope.processing);
      }

      // Enable the call next button
      setCanCall().catch(ErrorService.handler);
      getSubscriptionsAmount($scope.subscriptions).then(() => { });

      getSubscritionMetadata($scope.processing);
    },
    true,
  );

  const setCanCall = async () => {
    let waitingCheckedIn = 0;
    await forEach($scope.subscriptions, (value, key) => {
      if (value.status === 'waiting' && value.reason === 'checked-in') {
        waitingCheckedIn++;
      }
    });
    $scope.canCall = await (waitingCheckedIn > 0);
  }

  const setIconsForNewSubscriptions = (subscriptions) => {
    forEach(subscriptions, (value, key) => {
      setTypeIcon(value);
      setPriorityIcon(value);
    });
  }

  // Set the current queue according to the params.
  if (!lineId && !areaId && !groupId) {
    $scope.getShowTimer();
    // If there are not params, then set the first object of the linesAndAreas object as the current.
    QueueService.SetCurrent($scope.lines[0] || $scope.areas[0]);
  } else {
    QueueService.GetQueueById({
      lineId,
      areaId,
      groupId,
    })
      .then(async (queue) => {
        if (queue.realType === 'process') {
          queue.disabledAddPersonFromProcess = !queue.isWithoutAppointment;
        }

        if (queue.realType !== 'supervisor') {
          enqueueIn = {
            where: queue.realType,
            lineId: queue.realType === 'line' ? queue._id : undefined,
            areaId: queue.realType === 'process' ? queue._id : undefined,
            groupId: queue.realType === 'group' ? queue._id : undefined,
          };
          if (queue.realType === 'process') {
            $scope.filterData.showFilters = false;
          }
        }
        if (queue.realType === 'supervisor') {
          enqueueIn = {
            where: 'line',
            lineId: queue._id,
          };
        }
        // Set the current queue that I got by id
        QueueService.SetCurrent(queue);
        $scope.groupLines = map(map(get(queue, 'lines', [])), 'label');

        // Added the current queue to the scope
        $scope.currentQueue = QueueService.currentQueue;
        $scope.getShowTimer();

        // Get permissions
        if (QueueService.currentQueue && QueueService.currentQueue._id) {
          $scope.permissions = UserService.GetPermissions(
            GlobalsService.CurrentPlace._id,
            QueueService.currentQueue._id,
          );
          await getAllSubscriptions();
        }

        // Enable the call next button
        setCanCall().catch(ErrorService.handler);
        await getSubscriptionsAmount($scope.subscriptions);

      })
      .catch(ErrorService.handler);
  }

  const getAllSubscriptions = async () => {
    try {
      if (QueueService.currentQueue) {
        $scope.subscriptions = await SubscriptionService.GetAllByQueue(QueueService.currentQueue, { force: true });
        await getSubscriptionsAmount($scope.subscriptions);
      }
    } catch (error) {
      console.error('Error getting subscriptions from the queue: ', error);
    }
  };

  const getSubscriptionsForAllOperatorQueues = async (userQueueList) => {
    let subscriptionsFromAllUserQueues = [];
    try {
      for (const aQueue of userQueueList) {
        const subscriptionsPerQueue = await SubscriptionService.GetAllByQueue(aQueue, { force: true });
        subscriptionsFromAllUserQueues.push(subscriptionsPerQueue);
      }
    } catch (error) {
      console.error('Error getting subscriptions for all the operator queues: ', error);
    }

    return subscriptionsFromAllUserQueues.map(subs => Object.values(subs)).flat(1)
  }

  $scope.getShowTimer = () => {
    if ($scope.currentQueue && ['line', 'group'].includes($scope.currentQueue.realType)) {
      $scope.showAttentionTimer = get(
        $scope.currentQueue,
        `${$scope.currentQueue.realType === 'line' ? 'configuration.' : ''}showAttentionTimer`,
        false
      );
    }
  };

  $scope.counter = 0;
  $scope.realWaitingTime = restartTimer($scope.place);
  $scope.onTimeoutCurrent = () => {
    if ($scope.processing) {
      const now = moment().add($scope.secondsDifference, 'seconds').tz($scope.serverTime.placeTimezone);
      const called = moment($scope.processing.calledTime).tz($scope.serverTime.placeTimezone);
      const dateAtZero = new Date().setHours(0, 0, 0, 0);
      let diff = now.diff(called, 'seconds');

      if (diff >= 0 && now.isAfter(called)) {
        $scope.currentTimer = new Date(dateAtZero).setSeconds(diff);
      } else {
        diff = 0;
      }

      $scope.$apply();

      $scope.onTimeoutCurrentId = setTimeout($scope.onTimeoutCurrent, 1000);
    } else {
      clearTimeout($scope.onTimeoutCurrentId);
      $scope.currentTimer = restartTimer($scope.place);
      $scope.$apply();
    }
  };

  $scope.onTimeoutNext = () => {
    $scope.counter++;
    $scope.date = new Date(1970, 0, 1).setSeconds($scope.counter);
    $timeout($scope.onTimeoutNext, 1000);
  }
  $timeout($scope.onTimeoutNext, 1000);

  /**
   * Modals
   */
  // Modal to show user (subscription) info
  $scope.info = (subscription) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/subscription-modal.html',
      size: 'md',
      controller: 'InfoController',
      resolve: {
        // don't replace with 'short-hand'!
        subscriptionId: () => subscription._id,
        currentPlaceId: () => GlobalsService.CurrentPlace._id,
        waitingTime: () => getWaitingTime(subscription, $scope.secondsDifference, $scope.placeTimezone),
      },
    });
  };

  // Modal to enqueue/add user to line
  $scope.openEnqueueModal = () => {
    const enqueueModal = $uibModal.open({
      templateUrl: '/templates/components/modals/subscription-enqueue.html',
      size: 'md',
      controller: 'EnqueueController',
      resolve: {
        enqueueIn: () => enqueueIn,
        currentPlace: () => PlaceService.GetOneAsPromise(GlobalsService.CurrentPlace._id),
        currentOrganization: () => OrganizationService.GetCurrent(),
      },
    });

    enqueueModal.result.then(() => {
      $scope.tryFillSubscriptionsListAndAutoCallNext();
    });
  };

  // Modal to enqueue/add user to line
  $scope.openForwardModal = (subscription) => {
    const dateText = new Date($scope.currentTimer).toTimeString().split(' ')[0];

    const forwardModal = $uibModal.open({
      templateUrl: '/templates/components/modals/subscription-forward.html',
      size: 'md',
      controller: 'ForwardController',
      resolve: {
        subscription: () => subscription,
        line: () => QueueService.currentQueue,
        attentionTime: () => dateText,
      },
    });

    forwardModal.result.then(() => {
      // $scope.tryFillSubscriptionsListAndAutoCallNext();
    });
  };

  $scope.tryFillSubscriptionsListAndAutoCallNext = () => {
    $timeout(() => {
      $scope.getSubscriptionsIfSocketIsNotConnected();
      if ($scope.autoCallStatus.status === CallingAutomaticallyStatus.Active) {
        $scope.autoCallNext().then($scope.afterAutoCallNext);
      }
    }, 1500);
  };

  $scope.openRetainModal = (subscription, expirationDays) => {
    let daysLeft = expirationDays;

    if (subscription.retained.expirationDate) {
      const today = moment().startOf('day');
      const lastDay = moment(subscription.retained.expirationDate).startOf('day');
      daysLeft = lastDay.diff(today, 'days');
    }

    const daysText = daysLeft < 2 ? $translate.instant('day') : $translate.instant('days');
    const infoText = `${$translate
      .instant('retain_for_{days}')
      .replace('{days}', daysLeft)} ${daysText}`;

    dialog.reason(infoText).then((reason) => {
      SubscriptionService.Retain(subscription._id, QueueService.currentQueue._id, reason).catch(
        ErrorService.handler,
      );
    });
  };

  $scope.rejoin = (subscription) => {
    const name = $scope.getShowName(subscription);

    dialog.confirm($translate.instant('rejoin_{name}_sure').replace('{name}', name)).then(() => {
      // @TODO add translation to this notification
      NotificationService.Information(`Re-enviando a ${name}.`);
      SubscriptionService.Rejoin(subscription);
    });
  };

  $scope.$on('user-forwarded', (event) => {
    $scope.showCompanyData = false;
    $scope.showCommercialOfferData = false;
    $scope.showOfficialOperator = false;
    $scope.showForwarded = false;
    $scope.showSegment = false;
    $scope.showCategory = false;
  })

  /**
   * Refactored
   */
  // Forward subscription to supervisor
  $scope.forwardSubscription = (subscription) => {
    const name = $scope.getShowName(subscription);

    // First, ask the user if really wants to forward a subscription
    dialog
      .confirm($translate.instant('derive_{name}_supervisor_sure').replace('{name}', name))
      .then(() => {
        // Use the SubscriptionService to forward a subscription
        SubscriptionService.Forward(subscription._id, QueueService.currentQueue)
          .then(() => {
            $timeout(() => {
              const text = $translate.instant('user_{name}_derived_succ').replace('{name}', name);
              NotificationService.Success(text, $translate.instant('success'));
            });
          })
          .catch(ErrorService.handler);
      });
  };

  // Remove subscription
  $scope.removeSubscription = (subscription) => {
    const n = $scope.getShowName(subscription);

    dialog
      .confirm($translate.instant('list_remove_{name}_sure').replace('{name}', n))
      .then(() => {
        SubscriptionService.Remove(subscription._id, QueueService.currentQueue)
          .then(() => {
            NotificationService.Success(
              $translate.instant('list_{name}_remove_succ').replace('{name}', n),
            );
          })
          .catch(ErrorService.handler);
      })
      .catch((res) => res);
  };

  $scope.$on('auto-call-activated', (event) => {
    UserService.GetCurrentAsPromiseFromServer().then(currentUser => {
      $scope.user = currentUser;
      $scope.autoCallStatus = get(currentUser, 'callingAutomatically', CallingAutomaticallyDefaultValue);
      if ($scope.autoCallStatus.status === CallingAutomaticallyStatus.Active) {
        $scope.autoCallActive = true;
      }
    });
    $scope.getSubscriptionsIfSocketIsNotConnected();
    $scope.autoCallNext().then($scope.afterAutoCallNext);
  });

  $scope.$on('auto-call-paused', (event) => {
    UserService.GetCurrentAsPromiseFromServer().then(currentUser => {
      $scope.user = currentUser;
      $scope.autoCallStatus = get(currentUser, 'callingAutomatically', CallingAutomaticallyDefaultValue);
      if ($scope.autoCallStatus.status === CallingAutomaticallyStatus.Paused) {
        $scope.autoCallActive = false;
      }
    });
  });

  $scope.$on('automatic-call', (event, enabled) => {
    $scope.autoCallActive = enabled;
    if (!enabled) {
      const statusPause = {
        serviceId: lineId || areaId || groupId,
        serviceType: get($scope.currentQueue, 'realType', ''),
        status: CallingAutomaticallyStatus.Paused,
        reason: CallingAutomaticallyReason.None,
        userId: $scope.user._id,
      };

      UserService.UpdateCallingAutomaticallyStatus($scope.user._id, statusPause).then((data) => {
        $rootScope.$broadcast('autoCallStatus:update', statusPause);
        $rootScope.$broadcast('auto-call-paused');
      });
    }
  });

  $scope.autoCallNext = async (subscriptionsParam) => {
    // Get amount of subscriptions according to the type (waiting, completed ...), to be used in the next step
    const subscriptionsToCount = await (subscriptionsParam ? subscriptionsParam : $scope.subscriptions);
    await getSubscriptionsAmount(subscriptionsToCount);

    try {
      await $scope.isOperatorProcessingInOtherLine();
    } catch (error) {
      return;
    }

    if ($scope.processing || $scope.subscriptionsAmount.waitingCheckedIn === 0 || !$scope.canDone) {
      return;
    }

    await $scope.callNext();
  }

  // Call next subscription in the list
  $scope.callNext = async () => {
    $scope.enableTimer = false;
    $scope.pressedCallNext = moment();
    $scope.canDone = false;
    QueueService.CallNext(QueueService.currentQueue)
      .then(() => {
        $scope.showComplete = false;
        NotificationService.Success(
          $translate.instant('person_call_succ'),
          $translate.instant('success'),
        );
        if ($scope.autoCallStatus.status === CallingAutomaticallyStatus.Paused) {
          UserService.GetCurrentAsPromiseFromServer().then(currentUser => {
            $scope.user = currentUser;
            $scope.autoCallStatus = get(currentUser, 'callingAutomatically', CallingAutomaticallyDefaultValue);
            if ($scope.autoCallStatus.status === CallingAutomaticallyStatus.Active) {
              $scope.autoCallActive = true;
            }
            $rootScope.$broadcast('autoCallStatus:update', $scope.autoCallStatus);
          });
        }
        $scope.enableTimerFn();
        $timeout(() => {
          $scope.canDone = true;
        }, 3000);
      })
      .catch(error => {
        $scope.canDone = true;
        $scope.enableTimerFn();
        ErrorService.handler(error);
      });
  };

  // Call a specific subscription by id
  /*$scope.callTo = (subscriptionId) => {
    if ($scope.showComplete && !$scope.processing) {
      $scope.enableTimer = false;
      $scope.currentTimer = restartTimer($scope.place);
      $scope.pressedCallNext = moment();
      $scope.canDone = false;
      QueueService.CallTo(subscriptionId, QueueService.currentQueue)
        .then(() => {
          $scope.showComplete = false;
          NotificationService.Success(
            $translate.instant('person_call_succ'),
            $translate.instant('success'),
          );
          $scope.enableTimerFn();
          $timeout(() => {
            $scope.canDone = true;
          }, 3000);
        })
        .catch(error => {
          if (error.status === 406 && error.data === "queue.call-to.somebody-is-processing") {
            $scope.canDone = true;
          }
          $scope.enableTimerFn();
          ErrorService.handler(error);
        });
    } else {
      ErrorService.handler({
        status: 406,
        data: 'queue.call-to.somebody-is-processing',
      });
    }
  };*/

  $scope.callTo = (subscriptionId, event) => {
    $scope.pressedCallNext = moment();
    $scope.canDone = false;
    QueueService.CallTo(subscriptionId, QueueService.currentQueue)
      .then(() => {
        $scope.showComplete = false;
        NotificationService.Success(
          $translate.instant('person_call_succ'),
          $translate.instant('success'),
        );
        if ($scope.autoCallStatus.status === 'paused') {
          UserService.GetCurrentAsPromiseFromServer().then(currentUser => {
            $scope.user = currentUser;
            $scope.autoCallStatus = get(currentUser, 'callingAutomatically', { status: 'paused', reason: 'login', serviceId: '', serviceType: '' });
            if ($scope.autoCallStatus.status === 'active') {
              $scope.autoCallActive = true;
            }
            $rootScope.$broadcast('autoCallStatus:update', $scope.autoCallStatus);
          });
        }
        $timeout(() => {
          $scope.canDone = true;
        }, 3000);
      })
      .catch(error => {
        if (
          error.status === 406 &&
          [
            'queue.call-to.somebody-is-processing',
            'queue.call-next.somebody-is-processing',
            'queue.call-to.somebody-is-processing-same-subscription'
          ].includes(error.data)
        ) {
          $scope.canDone = true;
          $scope.enableTimerFn();
          if (event) {
            event.target.blur();
          }
        }
        ErrorService.handler(error);
      })
  };

  $scope.endSubscriptionFn = (subscription, status, reason) => {
    SubscriptionService.EndSubscription(subscription, status, reason)
      .then(() => {
        $timeout(() => {
          $scope.showTrackingData = false;
          $scope.showCompanyData = false;
          $scope.showCommercialOfferData = false;
          $scope.showOfficialOperator = false;
          $scope.showForwarded = false;
          $scope.showSegment = false;
          $scope.showCategory = false;
          $scope.toggleShowComplete();
          clearTimeout($scope.onTimeoutCurrentId);

          // Explicit calling to autoCallNext not necessary, after this is over watch() will call the autoCallNext()
          /*
          if ($scope.autoCallActive) {
            $scope.getSubscriptionsIfSocketIsNotConnected();
            if ($scope.autoCallStatus.status === CallingAutomaticallyStatus.Active) {
              $scope.autoCallNext().then($scope.afterAutoCallNext);
            }
          }
          */
          $scope.enableTimerFn();
        });
      })
      .catch(error => {
        clearTimeout($scope.onTimeoutCurrentId);
        $scope.enableTimerFn();
        ErrorService.handler(error);
      })
  }

  $scope.enableTimerFn = () => {
    $timeout(() => {
      $scope.enableTimer = true;
    }, 1000);
  }

  // Done a processing subscription
  // (options: complete, rejected or absent)
  $scope.endSubscription = (subscription, status, reason) => {
    $scope.enableTimer = false;
    $scope.counter = 0;
    $scope.realWaitingTime = restartTimer($scope.place);
    subscription.attentionTime = new Date($scope.currentTimer).toTimeString().split(' ')[0];
    $scope.currentTimer = restartTimer($scope.place);

    if (get($scope.checkDurationCompleteAction, 'enabled', false)) {
      const diff = moment().diff(subscription.calledTime, 'seconds');
      const showMessageBeforeSeconds = get($scope.checkDurationCompleteAction, 'showMessageBeforeSeconds', 0)
      if (showMessageBeforeSeconds > 0 && showMessageBeforeSeconds > diff) {
        dialog
          .confirm($translate.instant('you_are_completing_attention_in_less_than_{seconds}_seconds').replace('{seconds}', showMessageBeforeSeconds))
          .then(() => $scope.endSubscriptionFn(subscription, status, reason))
          .catch(() => 'canceled');
      } else {
        $scope.endSubscriptionFn(subscription, status, reason);
      }
    } else {
      $scope.endSubscriptionFn(subscription, status, reason);
    }
  };

  $scope.requeue = (subscription) => {
    const name = $scope.getShowName(subscription);

    dialog
      .confirm($translate.instant('confirm_requeue_{name}').replace('{name}', name))
      .then(() => {
        SubscriptionService.Requeue(subscription)
          .then(() => {
            NotificationService.Success(
              $translate.instant('requeue_success'),
              $translate.instant('success'),
            );
          })
          .catch(ErrorService.handler);
      });
  };

  $scope.getSubscriptionsIfSocketIsNotConnected = async () => {
    // MACRO-1369: Update subscriptions list from service in case of socket is not connected
    if (!SocketService.GetConnected()) {
      await getAllSubscriptions();
    }
  };

  $scope.afterAutoCallNext = () => {
    console.log('Auto Call Next completed');
  }

  $scope.getUserAssignedQueues = async () => {
    let userQueueList = [];
    for (const permission of $scope.user.permissions) {
      const aResource = permission.resourceGroup.resources[0];
      if (aResource.type === "group" || aResource.type === "line") {
        const queueToAdd = {
          type: aResource.type,
          _id: aResource._id,
          ordered: false // get from the queue
        };
        userQueueList.push(queueToAdd);
      }
    }

    return userQueueList;
  }

  $scope.isOperatorProcessingInOtherLine = async () => {
    const placeId = await GlobalsService.CurrentPlace._id;
    const showAutomaticCallMessage = ($scope.autoCallStatus && $scope.autoCallStatus.status === CallingAutomaticallyStatus.Active);
    const userQueueList = await $scope.getUserAssignedQueues();

    // load all subscriptions for this operator
    let subscriptionsFromAllUserQueues = await getSubscriptionsForAllOperatorQueues(userQueueList);
    if (!subscriptionsFromAllUserQueues) {
      return;
    }

    let anySubscription = find(subscriptionsFromAllUserQueues, {
      calledBy: userId,
      status: 'processing',
      placeId: placeId,
    });

    if (anySubscription && anySubscription.lineId !== $scope.currentQueue._id) {
      const lineFilter = {
        lineId: anySubscription.lineId,
      };
      const lineFound = await QueueService.GetQueueById(lineFilter);

      const errorMessageTemplate = showAutomaticCallMessage
        ? 'activate-calling-automatically.somebody-is-processing'
        : 'queue.call.user-is-processing-other-subscription';
      const lineNameProcessingOtherSubscription = (lineFound?.label || '');
      const messageProcessingOtherSubscription = $translate
        .instant(errorMessageTemplate)
        .replace('{lineName}', lineNameProcessingOtherSubscription);

      NotificationService.Error(messageProcessingOtherSubscription);
      throw new Error(messageProcessingOtherSubscription);
    }
  }

};

export default module.controller('QueueController', QueueController);
